export default __webpack_public_path__ + "static/media/51.25b5fafb.jpeg";